module.exports = "<button type=\"button\" class=\"cartOrderManagement-button linkButton _showOrderManagement\" ng-if=\"$ctrl.orderCount > 0\" ng-click=\"::$ctrl.toggleOrderManagement()\">\r\n    <span class=\"u-flexCenter\">\r\n        You have {{::$ctrl.orderCount}} open&nbsp; \r\n        <ng-pluralize \r\n            count=\"::$ctrl.orderCount\" \r\n            when=\"{'1': 'order', 'other': 'orders'}\">\r\n        </ng-pluralize>\r\n    </span>\r\n</button>"


//////////////////
// WEBPACK FOOTER
// ./src/shop/cart/cart-order-management.component.html
// module id = 382
// module chunks = 0